import axios from 'axios'
import { useEffect, useState, useCallback } from 'react'

const ENDPOINT = `https://www.cabiweb.dk/umbraco/api/employeeapi/getemployees?sort=A-Z`

export type Employee = {
  Name: string
  Titel: string
  Image: {
    url: string
    title: null
    alternativeText: null
  }
  Url: string
  Desc: string
  Phone: string
  Email: string
  Group: string
  LinkedIn: string
  SubjectAreas: ReadonlyArray<number>
  SortOrder: number
}

type Response =
  | { status: 'initial' }
  | { status: 'loading'; result: ReadonlyArray<Employee> }
  | { status: 'error'; error: Error }
  | { status: 'ok'; result: ReadonlyArray<Employee> }

export const useEmployees = (): [Response, () => void] => {
  const [state, setState] = useState<Response>({ status: 'initial' })

  const getEmployees = useCallback(async () => {
    setState((state) => ({
      status: 'loading',
      result: state.status === 'ok' ? state.result : []
    }))

    try {
      const response = await axios.get(ENDPOINT)
      const result: Employee[] = response.data.Employees

      setState({ status: 'ok', result })
    } catch (error) {
      setState({ status: 'error', error })
    }
  }, [])

  useEffect(() => {
    getEmployees()
  }, [getEmployees])

  return [state, getEmployees]
}
